import * as XLSX from "xlsx";
import { MarketplaceOrder } from "../../api/marketplace/MarketplaceOrdersApi";

const PREFERRED_HEADERS = [
  "OrderId",
  "ShopId",
  "MarketplacePlatform",
  "Status",
];

function exportValue(key: string, value: unknown): string | number | boolean {
  if (value === null || value === undefined) return "";
  if (key === "OrderId") return String(value);
  if (typeof value === "object") return JSON.stringify(value);
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value;
  }
  return String(value);
}

export function createMarketplaceOrdersWorkbook(orders: MarketplaceOrder[]) {
  const discoveredHeaders = Array.from(
    new Set(orders.flatMap((order) => Object.keys(order))),
  );
  const headers = [
    ...PREFERRED_HEADERS.filter((header) => discoveredHeaders.includes(header)),
    ...discoveredHeaders.filter((header) => !PREFERRED_HEADERS.includes(header)),
  ];
  const rows = orders.map((order) => Object.fromEntries(
    headers.map((header) => [header, exportValue(header, order[header])]),
  ));

  const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
  const orderIdColumn = headers.indexOf("OrderId");
  if (orderIdColumn >= 0) {
    for (let row = 1; row <= orders.length; row += 1) {
      const address = XLSX.utils.encode_cell({ r: row, c: orderIdColumn });
      const cell = worksheet[address];
      if (cell) {
        cell.t = "s";
        cell.v = String(cell.v);
        cell.z = "@";
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
  return workbook;
}

export function marketplaceOrdersFilename(date = new Date()) {
  return `marketplace-orders-export-${date.toISOString().split("T")[0]}.xlsx`;
}
